<template>
  <div class="dea-agency-data">
    <p class="dea-agency-data__label dea-wishlist-product__editor dea-heading--upper__s">{{ label }}</p>
    <p class="dea-agency-data__name-container">
      <span class="dea-agency-data__name dea-wishlist-product__title dea-heading--medium__ml">
        {{ name }}
      </span>
    </p>
    <ul class="dea-agency__chips-list" :class="{ 'dea-agency__chips-list--last': bottomChips }">
      <li v-for="(item, i) in chips" :key="i" class="dea-agency__chips-list__item">
        <Chips class="dea-agency__chip">{{ item.label }}</Chips>
      </li>
    </ul>
    <p class="dea-agency-data__address">
      {{ address }}
    </p>
    <p class="dea-agency-data__contacts">
      <span v-if="phone" class="dea-agency-data__contacts__phone">Tel: {{ phone }}<br /></span>
      <span v-if="fax" class="dea-agency-data__contacts__phone">Fax: {{ fax }}<br /></span>
      <span v-if="mail" class="dea-agency-data__contacts__mail"
        >E-Mail: <a :href="`mailto:${mail}`">{{ mail }}</a></span
      >
      <span v-if="website"
        >Website: <a :href="website">{{ website }}</a></span
      >
      <span v-if="dropPointLink"
        >Drop point: <a :href="dropPointLink">{{ dropPointLink }}</a></span
      >
    </p>
    <p v-if="note" class="dea-agency-data__contacts">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="note"></span>
    </p>
  </div>
</template>

<script>
import Chips from "@/components/elements/Chips";

export default {
  name: "AgencyData",

  components: { Chips },
  props: {
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    mail: {
      type: String,
      default: "",
    },
    fax: {
      type: String,
      default: "",
    },
    note: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    chips: {
      type: Array,
      default: () => [],
    },
    website: {
      type: String,
      default: "",
    },
    dropPointLink: {
      type: String,
      default: "",
    },
    bottomChips: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
